import reactLazyWithRetry from '@fatso83/retry-dynamic-import/react-lazy'
import { clsx } from 'clsx'

import { useAsyncApiScroll } from './helper'
import LastModifiedDate from '~/portal/components/LastModifiedDate'
import { AsyncAPIDefinition } from '~/portal/types/api.definitions'

interface AsyncApiRendererProps {
  definition: AsyncAPIDefinition
  hash: string
  containerRef: HTMLDivElement | undefined
  lastModifiedDate?: string
  isConsumerSide?: boolean
}

const AsyncApiComponent = reactLazyWithRetry(() => import('@asyncapi/react-component').then(comp => ({ default: comp.default } as any)))

export default function AsyncApiRenderer({ definition, hash, containerRef, lastModifiedDate, isConsumerSide }: AsyncApiRendererProps) {
  useAsyncApiScroll(containerRef, hash)

  const config = {
    schemaID: 'custom-spec',
    show: {
      operations: true,
      errors: false,
    },
  }

  return (
    <div className={clsx('pt-6 bg-(--sp-color-surface)', isConsumerSide && 'md:px-3 xl:px-0 md:pt-9 xl:pt-6')}>
      <LastModifiedDate date={lastModifiedDate} className="pb-2 pl-6 text-(--sp-color-text-muted)" />
      <AsyncApiComponent schema={definition} config={config} />
    </div>
  )
}